import React from 'react';
import "../styles/TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <nav className="breadcrumb">
        <a href="/">Home</a> &raquo; <span>TERMS AND CONDITIONS</span>
      </nav>
      <h1>TERMS AND CONDITIONS</h1>
      <p className="dates">
        <strong>Effective Date:</strong> December 5, 2024<br />
        <strong>Last Updated:</strong> December 5, 2024
      </p>

      <section className="section">
        <h2>1. Service Provider Information</h2>
        <p>
          The application is provided by:
        </p>
        <p>
          <strong>Service Provider:</strong> Patryk Kotłowski JDG<br />
          <strong>Registered office:</strong> Otomino, Poland<br />
          <strong>Email:</strong> <a href="mailto:support@dialectoapp.com">support@dialectoapp.com</a><br />
          <strong>Website:</strong> <a href="https://dialectoapp.com">https://dialectoapp.com</a>
        </p>
      </section>

      <section className="section">
        <h2>2. Scope of Services</h2>
        <p>
          The Dialecto application provides tools designed to help users learn languages and other educational content through AI-based interactions.
        </p>
        <p>
          Its main features include:
        </p>
        <ul>
          <li>AI-powered conversations and exercises supporting language practice and education.</li>
          <li>Personalized content based on user preferences and learning progress.</li>
        </ul>
        <p>
          While Dialecto aims to enhance the learning experience, it should not be considered a substitute for certified educational programs or professional tutoring.
        </p>
      </section>

      <section className="section">
        <h2>3. Liability for AI-Generated Content</h2>
        <p>
          Dialecto is not responsible for the accuracy, completeness, or consequences of using AI-generated content.
          Although every effort is made to ensure the highest quality, AI responses may contain errors, outdated information, or linguistic inaccuracies.
        </p>
        <p>
          The AI system does not provide factual guarantees or professional advice. It is not a substitute for human judgment or expert consultation.
          Users are solely responsible for reviewing and verifying all AI-generated content before relying on it.
        </p>
      </section>

      <section className="section">
        <h2>4. Age Restrictions</h2>
        <p>
          The application is intended for users aged 16 years or older.
          Individuals under 16 may use the app only under the supervision of a parent or guardian.
          By creating an account or using the app, users confirm that they meet this age requirement.
        </p>
      </section>

      <section className="section">
        <h2>5. User Responsibilities</h2>
        <p>
          Users agree to use the application lawfully, ethically, and responsibly.
          They must not use the app to:
        </p>
        <ul>
          <li>engage in illegal, harmful, or abusive behavior;</li>
          <li>distribute offensive, defamatory, or misleading content;</li>
          <li>manipulate or interfere with the app's operation.</li>
        </ul>
        <p>
          Users are fully responsible for their activity and for any consequences arising from interactions with AI-generated content.
        </p>
      </section>

      <section className="section">
        <h2>6. Payments and Subscriptions</h2>
        <p>
          Some features of Dialecto may be available through in-app purchases or subscription plans.
        </p>
        <p>
          Accepted payment methods include Apple Pay and Google Pay.
        </p>
        <p>
          Prices, billing cycles, and applicable taxes are displayed before purchase.
        </p>
        <p>
          Users must ensure that payment details are accurate and up to date.
        </p>
        <p>
          If a subscription is canceled, access remains active until the end of the current billing period.
        </p>
        <p>
          No partial refunds are issued for unused time within a billing cycle.
        </p>
        <p>
          All transactions are processed through Apple or Google under their respective terms of service.
        </p>
      </section>

      <section className="section">
        <h2>7. Refund Policy</h2>
        <p>
          Users in the European Union have the right to withdraw from a digital service purchase within 14 days, unless they have given explicit consent to begin using the service before the withdrawal period ends.
        </p>
        <p>
          Refunds for purchases made via the App Store or Google Play must be requested directly through the respective store's refund process.
          Dialecto may approve additional refunds only if:
        </p>
        <ul>
          <li>the purchased service is unavailable due to Dialecto's fault; and</li>
          <li>the user has not significantly used the purchased feature.</li>
        </ul>
        <p>
          Approved refunds will be processed within 10 business days of confirmation.
        </p>
      </section>

      <section className="section">
        <h2>8. Data Protection and Privacy</h2>
        <p>
          Personal data is collected and processed in accordance with the General Data Protection Regulation (GDPR) and other applicable laws.
        </p>
        <p>
          For detailed information, please review our Privacy Policy.
        </p>
        <p>
          Users may exercise their data rights — including access, correction, deletion, and portability — by contacting <a href="mailto:support@dialectoapp.com">support@dialectoapp.com</a>.
        </p>
      </section>

      <section className="section">
        <h2>9. Complaints and Customer Support</h2>
        <p>
          Complaints or issues (including payment or feature-related problems) can be submitted to <a href="mailto:support@dialectoapp.com">support@dialectoapp.com</a>.
          We aim to respond within 10 business days.
          If you are not satisfied with the resolution, you may escalate the issue through applicable legal channels (see Section 11).
        </p>
      </section>

      <section className="section">
        <h2>10. Amendments to Terms</h2>
        <p>
          These Terms and Conditions may be updated periodically.
          The "Last Updated" date at the top indicates the current version.
        </p>
        <p>
          In case of significant updates affecting user rights or paid services, users will be notified in advance through the app or by email.
          Continued use of the app after updates constitutes acceptance of the revised terms.
        </p>
      </section>

      <section className="section">
        <h2>11. Governing Law and Jurisdiction</h2>
        <p>
          These Terms are governed by the laws of the Republic of Poland.
          Any disputes will be resolved by the competent court in Poland, unless otherwise required by consumer protection law.
        </p>
        <p>
          For users residing in the European Union, this choice of law does not limit any mandatory consumer rights under local legislation.
          Alternative dispute resolution (e.g., mediation or arbitration) may be used if both parties agree.
        </p>
      </section>

      <section className="section">
        <h2>12. Purpose of AI-Generated Content</h2>
        <p>
          AI-generated content in the Dialecto app is provided for educational, informational, and entertainment purposes only.
          It is not professional, academic, or legal advice.
          Users should independently verify the relevance and accuracy of any generated information before relying on it.
        </p>
      </section>

      <section className="section">
        <h2>13. Availability of Terms</h2>
        <p>
          The latest version of these Terms and Conditions is always available at:<br />
          👉 <a href="https://dialectoapp.com/terms">https://dialectoapp.com/terms</a>
        </p>
        <p>
          By accessing or using Dialecto, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
        </p>
      </section>

      <section className="section contact-info">
        <h2>📩 Contact Information</h2>
        <p>
          <strong>Patryk Kotłowski JDG</strong><br />
          Otomino, Poland<br />
          Email: <a href="mailto:support@dialectoapp.com">support@dialectoapp.com</a><br />
          Website: <a href="https://dialectoapp.com">https://dialectoapp.com</a>
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
